import React from 'react';
import { connect } from 'react-redux';
import { EMPTY_STEP_BAR } from './saleStepBarHelpers';
import './packageBar.scss';

const PackageBarStepper = ({ stepBar = EMPTY_STEP_BAR }) => {
  if (!stepBar?.show) {
    return null;
  }

  return (
    <div className="package-bar package-bar--stepper">
      <div className="package-bar__steps">
        {stepBar.steps.map((step) => (
          <div
            key={step.key}
            className={`package-bar__step package-bar__step--${step.status}`}
          >
            <span className="package-bar__label">{step.label}</span>
            <div className="package-bar__indicator">
              <span
                className="package-bar__indicator-fill"
                style={{ width: `${step.fillPercent}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const PackageBarPill = ({ packageName }) => {
  if (!packageName) {
    return null;
  }

  return (
    <div className="package-bar">
      <div className="package-bar-wrapper">
        <div className="package-item">{packageName}</div>
      </div>
    </div>
  );
};

const PackageBar = ({ stepBar = EMPTY_STEP_BAR, packageName, showStepper }) => {
  if (showStepper) {
    return <PackageBarStepper stepBar={stepBar} />;
  }

  return <PackageBarPill packageName={packageName} />;
};

const mapStateToProps = (state) => ({
  stepBar: state.saleJetBlock.stepBar,
});

export default connect(mapStateToProps)(PackageBar);
